import { useCallback, useContext, useEffect, useState } from 'react';
import { Permissions } from '../shared/models/permissions.enum';
import { AuthService } from '../Auth/AuthService';
import UserDetailsContext from '../Context/userDetails.context';
import { User } from 'oidc-client';

export const UseHaveAnyPermissions = (permissions: Permissions[]) => {
  const [haveAnyRequiredPermission, setHaveAnyRequiredPermission] = useState<boolean>();

  const { user } = useContext<{ user: User | null }>(UserDetailsContext);

  const checkPermissions = useCallback(() => {
    const anyRequired = AuthService.hasAnyPermission(permissions, user);
    setHaveAnyRequiredPermission(anyRequired);
  }, [permissions, user]);

  useEffect(() => {
    checkPermissions();
  }, [checkPermissions]);

  return haveAnyRequiredPermission;
};
